import axios from 'axios';
import { request } from '@wix/da-shared-react/pkg/xhr';
import snakeCase from 'lodash/snakeCase';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { API_BASE_PATH } from '../../server/routes/constants';
import {
  fetchModuleConfig,
  fetchModuleConfigSuccess,
  saveModuleConfig,
} from '../actions/modules';
import { getModuleType, getModuleConfig } from '../selectors/modules';
import { getModuleInitActions } from '../../server/store/initActions/modules';

function* postModuleEndpoint(endpoint, params) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/${endpoint}`,
    data: transformParamNames(params),
  });
}

export function* runModuleInitActions(moduleResponse, requestParams = {}) {
  const actions = getModuleInitActions(moduleResponse);
  if (!actions || !actions.length) {
    // No module actions found
    return;
  }
  // dispatch actions
  yield all(actions.map(moduleAction => put(moduleAction)));
}

function getModuleEndpoint(endpoint, params) {
  return axios
    .get(`${API_BASE_PATH}/module/${endpoint}`, {
      params: transformParamNames(params),
    })
    .then(response => response.data)
    .catch(response => false);
}

function transformParamNames(params) {
  return Object.keys(params).reduce((transformedParams, key) => {
    switch (key) {
      case 'moduleId':
      case 'folderId':
      case 'countryId':
        // convert to lovercase
        transformedParams[key.toLowerCase()] = params[key];
        break;
      case 'sourceType':
      case 'viewMode':
      case 'slideImageFit':
      case 'sortBy':
      // custombox
      case 'backgroundType':
      case 'imageDisplayMode':
      case 'imageDeviationid':
      case 'imageTint':
      // about module
      case 'dobDay':
      case 'dobMonth':
      case 'dobYear':
      case 'websiteLabel':
      case 'showBadges':
      case 'socialLinks':
      case 'isArtist':
        // convert to snake_case
        transformedParams[snakeCase(key)] = params[key];
        break;
      default:
        transformedParams[key] = params[key];
    }
    return transformedParams;
  }, {});
}

export function* saveModuleConfigSaga(action) {
  const { payload } = action;
  const moduleType = yield select(getModuleType, payload.moduleId);
  const {
    config: { version },
  } = yield select(getModuleConfig, payload.moduleId);
  const response = yield call(postModuleEndpoint, `${moduleType}/save`, {
    ...payload,
    version,
  });

  // Basic error handling
  if (!response || response.error) {
    if (response.errorDescription) {
      alert(`Error: ${response.errorDescription}`);
      return;
    }
    alert('Failed to save, please try again...');
    return;
  }

  if (response) {
    // TODO: temporary fix, module returned by config/save endpoint is not the same as the ones return by init/section endpoints
    const sanitizedModule = {
      id: payload.moduleId,
      type: moduleType,
      version: version + 1, // new version is not returned by the save endpoint, since the API call was successful assume it was incremented by one
      moduleData: response.module,
    };
    if (process.env.NODE_ENV !== 'production' && payload.title !== undefined) {
      sanitizedModule.moduleData.title = payload.title;
    }
    yield runModuleInitActions(sanitizedModule);
  }
}
export function* fetchModuleConfigSaga(action) {
  const { payload } = action;
  const moduleType = yield select(getModuleType, payload.moduleId);
  const response = yield call(
    getModuleEndpoint,
    `${moduleType}/config`,
    payload
  );

  if (response) {
    // update module data in the store
    yield put(
      fetchModuleConfigSuccess({ id: payload.moduleId, config: response })
    );
    return;
  }
}

export default function* rootModulesSaga() {
  yield all([
    takeEvery(saveModuleConfig, saveModuleConfigSaga),
    takeEvery(fetchModuleConfig, fetchModuleConfigSaga),
  ]);
}
